import en from '../i18n/lang/en'
import Vue from 'vue'
import Router from 'vue-router'
import CommerViews from '@/views/commerViews'
import Login from '@/views/login/index'
import Layout from '@/views/layout/layout'
import HomeMain from '@/views/index/mainIndex'

// 不是必须加载的组件使用懒加载

const NotFound = () =>
    import ('@/page404')

const departmentmanage = () =>
    import ('@/views/hospital/Department') //部门管理
const hospitalsetting = () =>
    import ('@/views/hospital/hospitalsetting') //医院设置
const department = () =>
    import ('@/views/hospital/Department') // 部门管理
const dictmanage = () =>
    import ('@/views/hospital/dictmanage') //字典管理
const dictsortmanage = () =>
    import ('@/views/hospital/dictsortmanage') //字典分类管理

const rolemanage = () =>
    import ('@/views/hospital/rolemanage') //角色管理
const usermanage = () =>
    import ('@/views/hospital/usermanage') //用户管理
const menumanage = () =>
    import ('@/views/hospital/menumanage') //菜单管理
const authmanage = () =>
    import ('@/views/hospital/authmanage') //权限管理
const introduceDetail = () =>
    import ('@/views/hospital/scaleIntroduceDetail') //量表介绍详情

const questionManage = () =>
    import ('@/views/hospital/questionManage') //菜单管理
const scaleManage = () =>
    import ('@/views/hospital/scaleManage') //权限管理
const scaleKeyword = () =>
    import ('@/views/hospital/scaleKeyword') //关键字
const DesignForm = () =>
    import ('@/views/hospital/DesignForm') //权限管理
const prescribe = () =>
    import ('@/views/hospital/prescribe')
const admQuery = () =>
    import ('@/views/hospital/admQuery')
const patientQuery = () =>
    import ('@/views/hospital/patientQuery')
const diagnosisManage = () =>
    import ('@/views/hospital/diagnosisManage')
const alarm = () =>
    import ('@/views/hospital/alarm')
const register = () =>
    import ('@/views/hospital/register')
const chregister = () =>
    import ('@/views/hospital/chRegister')
const StartTest = () =>
    import ('@/views/hospital/StartTest')
const packageManage = () =>
    import ('@/views/hospital/packageManage')
const examQuery = () =>
    import ('@/views/hospital/examQuery')
const physiqueQuery = () =>
    import ('@/views/hospital/physiqueQuery')
const physiqueResultQuery = () =>
    import ('@/views/hospital/physiqueResultQuery')
const StartAnswering = () =>
    import ('@/views/hospital/StartAnswering')

const TrainQuery = () =>
    import ('@/views/hospital/TrainQuery')
const TrainReg = () =>
    import ('@/views/hospital/TrainReg')
    /* 基础设置里面的常用量表 */
const scaleCommon = () =>
    import ('@/views/hospital/scaleCommon') //常用量表
const focusScaleMgr = () =>
    import ('@/views/hospital/focusScaleMgr') //常用量表
const alarmManage = () =>
    import ('@/views/hospital/alarmManage') //量表告警管理
const FunctionSet = () =>
    import ('@/views/hospital/FunctionSet') //量功能设置

const hospitalManage = () =>
    import ('@/views/hospital/hospitalManage') //医院管理
const doctorListManage = () =>
    import ('@/views/hospital/doctorListManage') //医生管理
const patientManage = () =>
    import ('@/views/hospital/patientManage') //患者管理

const ordinaryIndex = () =>
    import ('@/views/index/ordinaryIndex') //普通首页

const physicalPlan = () =>
    import ('@/views/hospital/physicalPlan')

const addPlan = () =>
    import ('@/views/hospital/addPlan')
const setScaleKeyword = () =>
    import ('@/views/hospital/setScaleKeyword')
    // 体检计划图像统计
const physicalPlanEcharts = () =>
    import ('@/views/hospital/physicalPlanEcharts')

const scaledetail = () =>
    import ('@/views/hospital/scaledetail')

Vue.use(Router)

/* const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
} */


let routeName = en.routeName
let defaultRouter = [{
        path: '/',
        redirect: '/index',
        hidden: true,
        children: []
    },
    {
        path: '/login',
        component: Login,
        name: 'Login',
        hidden: true,
        meta: {
            role: ['普通用户', '管理员']
        },
        children: []
    },
    {
        path: '/register', //测试
        component: register,
        name: 'register',
        hidden: true,
        children: []
    },
    {
        path: '/mentalHealthReport', //资中人民医院体检报告展示
        component: ()=>import("@/views/hospital/mentalHealthReport"),
        name: 'mentalHealthReport',
        hidden: true,
        children: []
    },
    {
        path: '/chregister', //测试
        component: chregister,
        name: 'chregister',
        hidden: true,
        children: []
    },
    {
        path: '/StartTest', //开始测试
        iconCls: 'el-icon-info', // 图标样式class
        component: StartTest,
        hidden: true,
        meta: {
            role: ['普通用户']
        },
        children: []
    },
    {

        path: '/StartAnswering', //开始测试
        iconCls: 'el-icon-info', // 图标样式class
        component: StartAnswering,
        hidden: true,
        meta: {
            role: ['普通用户']
        },
        children: []
    },
    {
        path: '/',
        iconCls: 'fa fa-dashboard', // 图标样式class
        name: routeName.home,
        component: Layout,
        componentname: 'home',
        meta: {
            role: ['管理员']
        },
        // alone: true,
        children: [{
                path: '/ordinaryIndex',
                iconCls: 'fa fa-dashboard', // 图标样式class
                name: '主页1',
                componentname: 'ordinaryIndex',
                component: ordinaryIndex,
                children: []
            },
            {
                path: '/index',
                iconCls: 'fa fa-dashboard', // 图标样式class
                name: '主页',
                componentname: 'index',
                component: HomeMain,
                children: []
            },

        ]
    },


    {
        path: '/404',
        component: NotFound,
        componentname: '404',
        name: '404',
        hidden: true,
        children: []
    }
]

let addRouter = [{
        path: '/', //系统管理
        iconCls: 'el-icon-setting', // 图标样式class
        name: routeName["systemSettings"],
        component: Layout,
        componentname: 'systemSettings',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/departmentManage', //部门管理导航
                iconCls: 'fa fa-calendar-plus-o', // 图标样式class
                name: routeName["departmentManage"],
                componentname: 'departmentManage',
                component: departmentmanage,
                children: []
            },
            {
                path: '/introduceDetail', //量表介绍详情
                iconCls: 'fa fa-sitemap', // 图标样式class
                name: "introduceDetail",
                component: introduceDetail,
                children: []
            },
            {
                path: '/userManage', //用户管理导航
                iconCls: 'fa fa-users', // 图标样式class
                name: routeName["userManage"],
                componentname: 'userManage',
                component: usermanage,
                children: []
            },
            {
                path: '/scaleKeyword', //量表管理导航
                iconCls: 'fa fa-sliders', // 图标样式class
                name: routeName["scaleKeyword"],
                componentname: 'scaleKeyword',
                component: scaleKeyword,
                children: []
            },
            {
                path: '/scaledetail', //菜单管理导航
                iconCls: 'el-icon-menu', // 图标样式class
                name: routeName["scaledetail"],
                componentname: 'scaledetail',
                component: scaledetail,
                children: []
            },
            {
                path: '/menuManage', //菜单管理导航
                iconCls: 'el-icon-menu', // 图标样式class
                name: routeName["menuManage"],
                componentname: 'menuManage',
                component: menumanage,
                children: []
            },
            {
                path: '/roleManage', //角色管理导航
                iconCls: 'el-icon-s-custom', // 图标样式class
                name: routeName["roleManage"],
                componentname: 'roleManage',
                component: rolemanage,
                children: []
            },
            {
                path: '/authManage', //权限管理导航
                iconCls: 'fa fa-sitemap', // 图标样式class
                name: routeName["authManage"],
                componentname: 'authManage',
                component: authmanage,
                children: []
            }
        ]
    },

    {
        path: '/baseData', //基础数据管理
        iconCls: 'fa fa-telegram', // 图标样式class
        name: routeName["baseData"],
        component: Layout,
        componentname: 'baseData',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/dictManage', //字典管理导航
                iconCls: 'fa fa-book', // 图标样式class
                name: routeName["dictManage"],
                componentname: 'dictManage',
                component: dictmanage,
                children: []
            },
            {
                path: '/scaleManage', //量表管理导航
                iconCls: 'fa fa-sliders', // 图标样式class
                name: routeName["scaleManage"],
                componentname: 'scaleManage',
                component: scaleManage,
                children: []
            },
            {
                path: '/questionManage', //问题管理导航
                iconCls: 'el-icon-s-opportunity', // 图标样式class
                name: routeName["questionManage"],
                componentname: 'questionManage',
                component: questionManage,
                children: []
            },
            {
                path: '/DesignForm', //问题管理导航
                iconCls: 'el-icon-warning-outline', // 图标样式class
                name: routeName["DesignForm"],
                component: DesignForm,
                hidden: true,
                children: []
            }
        ]
    },
    {
        path: '/measure', //基础数据管理
        iconCls: 'el-icon-s-marketing', // 图标样式class
        name: routeName["measure"],
        component: Layout,
        componentname: 'measure',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/prescribe', //患者登记
                iconCls: 'fa fa-address-card', // 图标样式class
                name: routeName["prescribe"],
                component: prescribe,
                children: []
            },
            {
                path: '/admQuery', //测试
                iconCls: 'el-icon-s-order', // 图标样式class
                name: routeName["admQuery"],
                component: admQuery,
                children: []
            },
            {
                path: '/patientQuery', //患者查询
                iconCls: 'el-icon-user-solid', // 图标样式class
                name: routeName["patientQuery"],
                component: patientQuery,
                children: []
            },
            {
                path: '/diagnosisManage', //心理诊断
                iconCls: 'el-icon-user-solid', // 图标样式class
                name: routeName["diagnosisManage"],
                component: diagnosisManage,
                children: []
            },
            {
                path: '/alarm', //测评告警
                iconCls: 'el-icon-warning', // 图标样式class
                name: routeName["alarm"],
                component: alarm
            }
        ]
    },
    {
        path: '/hospitals', //医院管理
        iconCls: 'el-icon-school', // 图标样式class
        name: routeName["hospitalManage1"],
        component: Layout,
        componentname: 'hospitals',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/hospitalManage', //医院管理
                iconCls: 'fa fa-folder-o', // 图标样式class
                name: routeName["hospitalManage"],
                component: hospitalManage,
                children: []
            },
            {
                path: '/doctorListManage', //医生管理
                iconCls: 'fa fa-folder-o', // 图标样式class
                name: routeName["doctorListManage"],
                component: doctorListManage,
                children: []
            },
            {
                path: '/patientManage', //患者管理
                iconCls: 'fa fa-folder-o', // 图标样式class
                name: routeName["patientManage"],
                component: patientManage,
                children: []
            }
        ]
    },
    {
        path: '/examManage', //体检管理
        iconCls: 'fa fa-dashboard', // 图标样式class
        name: routeName["examManage"],
        component: Layout,
        componentname: 'examManage',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/packageManage', //套餐查询
                iconCls: 'el-icon-first-aid-kit', // 图标样式class
                name: routeName["packageManage"],
                component: packageManage,
                children: []
            },
            {
                path: '/examQuery', //体检查询
                iconCls: 'fa fa-bed', // 图标样式class
                name: routeName["examQuery"],
                component: examQuery,
                children: []
            },
            {
                path: '/physicalPlan',
                iconCls: 'fa fa-user-plus',
                name: '体检计划',
                component: physicalPlan,
                children: []
            },
            {
                path: '/setScaleKeyword',
                iconCls: 'fa fa-user-plus',
                name: 'setScaleKeyword',
                component: setScaleKeyword,
                children: []
            },
            {
                path: '/addPlan',
                iconCls: 'fa fa-user-plus',
                name: 'addPlan',
                component: addPlan,
                children: []
            },
            {
                path: '/physicalPlanEcharts',
                name: routeName["physicalPlanEcharts"],
                component: physicalPlanEcharts,
                children: []
            }

        ]
    },
    {
        path: '/chineseMedicine', //中医体质辨识
        iconCls: 'fa fa-universal-access', // 图标样式class
        name: routeName["chineseMedicine"],
        component: Layout,
        componentname: 'chineseMedicine',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/physiqueQuery', //体质辨识
                iconCls: 'fa fa-binoculars', // 图标样式class
                name: routeName["physiqueQuery"],
                component: physiqueQuery,
                children: []
            },
            {
                path: '/physiqueResultQuery', //结果查询
                iconCls: 'fa fa-tasks', // 图标样式class
                name: routeName["physiqueResultQuery"],
                component: physiqueResultQuery,
                children: []
            },

        ]
    },
    /* 新增基础设置模块 */
    {
        path: '/baseset', //基础设置
        iconCls: 'el-icon-s-tools', // 图标样式class
        name: routeName["baseset"],
        component: Layout,
        componentname: 'baseset',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/scaleCommon', //常用量表
                iconCls: 'el-icon-menu', // 图标样式class
                name: routeName["scaleCommon"],
                component: scaleCommon,
            },
            {
                path: '/alarmManage', //量表告警管理
                iconCls: 'el-icon-mouse', // 图标样式class
                name: routeName["alarmManage"],
                component: alarmManage,
            }, {
                path: '/FunctionSet', //量表告警管理功能设置
                iconCls: 'el-icon-mouse', // 图标样式class
                name: routeName["FunctionSet"],
                component: FunctionSet,
            }
        ]
    },
    // 新增重点量表管理
    {
        path: '/focusScale', //重点量表管理
        iconCls: 'fa fa-lightbulb-o', // 图标样式class
        name: routeName["focusScale"],
        component: Layout,
        componentname: 'focusScale',
        meta: {
            role: ['管理员']
        },
        children: [{
            path: '/focusScaleMgr', //常用量表
            iconCls: 'fa fa-sitemap', // 图标样式class
            name: routeName["focusScaleMgr"],
            component: focusScaleMgr,
        }]
    },

    {
        path: '/Train', //心里训练
        iconCls: 'fa fa-heartbeat', // 图标样式class
        name: routeName["Train"],
        component: Layout,
        componentname: 'Train',
        meta: {
            role: ['管理员']
        },
        children: [{
                path: '/TrainReg', //患者查询
                iconCls: 'el-icon-edit-outline', // 图标样式class
                name: routeName["TrainReg"],
                component: TrainReg,
                children: []
            },
            {
                path: '/TrainQuery', //套餐查询
                iconCls: 'el-icon-help', // 图标样式class
                name: routeName["TrainQuery"],
                component: TrainQuery,
                children: []
            },


        ]
    }

]
export default new Router({
    routes: defaultRouter
})
export {
    defaultRouter,
    addRouter
}


// WEBPACK FOOTER //
// ./src/router/index.js